'use client';
import React from 'react';
import SpecificationData from '../../SpecificationData';

export default function Amenities(props: any) {
  const { t } = props;
  const tabContent = [
    {
      type: 'amenities',
      heading: t[''],
      description: t['beachHouseAmenitiesDescription'],
      listElement: t['beachHouseAmenities'],
    },
  ];
  return (
    <>
      {/* @ts-ignore */}
      <SpecificationData t={t} tabs={tabContent} />
    </>
  );
}
